import { isUnauthenticatedError } from "util/error-tracking";

export const sendCodeFailureMessage = (error: unknown): string =>
    isUnauthenticatedError(error)
        ? "Your session has expired. Please sign in again to continue."
        : "Failed to send two-factor code. Refresh and try again. If you continue to have trouble, please contact support.";
